/*=========================================================================================
  File Name: mutations.js
  Namespace: collections
  Description: Vuex Store - Collection mutations
==========================================================================================*/

import { buildCollectionState } from './state'
import cloneDeep from 'lodash.clonedeep'

const mutations = {
  STORE_CURRENT_COLLECTION(state, collection) {
    state.currentCollection = {
      ...state.currentCollection,
      ...collection,
      categories: collection.categories ? collection.categories : [],
      learning_areas: collection.learning_areas
        ? collection.learning_areas
        : [],
    }
  },
  STORE_LIST_COLLECTIONS_CSV(state, collections) {
    state.collectionsCsv = collections
  },
  STORE_LIST_COLLECTIONS(state, collections) {
    state.collectionList = {
      ...state.quizList,
      ...collections.entries,
    }
    state.count = collections.count
    state.next = collections.next
    state.previous = collections.previous
    state.results = [...collections.results]
  },
  STORE_COLLECTION_STRUCTURE(state, content) {
    state.currentCollection = {
      ...state.currentCollection,
      ...cloneDeep(content),
    }
  },
  RESET_CURRENT_COLLECTION(state) {
    state.currentCollection = buildCollectionState()
  },
  RESET_CURRENT_COLLECTION_CONTENT(state) {
    state.currentCollection.content = []
  },
  ADD_LEAF_TO_STRUCTURE(state, content) {
    content.parent.content.push(content.leaf)
  },
  ADD_LEAFS_INTO_STRUCTURE(state, { afterOf, leafs }) {
    for (let i = 0; i < state.currentCollection.content.length; i++) {
      let group = state.currentCollection.content[i]
      for (let j = 0; j < group.content.length; j++) {
        let topic = group.content[j]
        for (let k = 0; k < topic.content.length; k++) {
          let leaf = topic.content[k]
          if (leaf.uuid === afterOf) {
            topic.content.splice(k + 1, 0, ...leafs)
          }
        }
      }
    }
  },
  // param content = {item, parent}
  REMOVE_LEAF_TO_STRUCTURE(state, content) {
    const index = content.parent.content.indexOf(content.item)
    if (index > -1) {
      content.parent.content.splice(index, 1)
    }
  },
  // @params: nameObject = {oldName, newName, type, item}
  RENAME_GROUP(state, nameObject) {
    nameObject.item.name = nameObject.newName
  },
  // @params: group = {parent, index, type}
  ADD_GROUP_TO_STRUCTURE(state, group) {
    if (!group.parent) {
      state.currentCollection.content.splice(group.index, 0, {
        name: '',
        content_type: group.type,
        content: [],
      })
    } else {
      group.parent.content.splice(group.index, 0, {
        name: '',
        content_type: group.type,
        content: [],
      })
    }
  },
  // param content = {parent, index}
  REMOVE_GROUP_OF_STRUCTURE(state, group) {
    if (!group.parent) {
      state.currentCollection.content.splice(group.index, 1)
    } else {
      group.parent.content.splice(group.index, 1)
    }
  },
  UPDATE_CONTENT_ORDER(state, { item, newContent }) {
    if (item) {
      item.content = newContent
    } else {
      state.currentCollection = {
        ...state.currentCollection,
        content: newContent,
      }
    }
  },
  ADD_FILE_CURRENT_COLLECTION(state, file) {
    state.currentCollection.files = [...state.currentCollection.files, file]
  },
  REMOVE_FILE_CURRENT_COLLECTION(state, file) {
    const index = state.currentCollection.files.findIndex(
      (f) => f.id === file.id
    )
    state.currentCollection.files.splice(index, 1)
  },
  ADD_PASS_TO_COLLECTION_PASSES(state, pass) {
    state.currentCollection.direct_passes.push(pass.id)
  },
  REMOVE_PASS_FROM_COLLECTION_PASSES(state, pass) {
    const index = state.currentCollection.direct_passes.findIndex(
      (id) => id === pass.id
    )
    state.currentCollection.direct_passes.splice(index, 1)
  },
  SAVE_HUNDRED_COLLECTIONS(state, collections) {
    state.hundredCollections = collections
  },
}

export default mutations
